import { defineAsyncComponent } from 'vue'
export default {
  area: defineAsyncComponent(() => import("/tmp/tmpkyj7iuwo/layouts/area.vue").then(m => m.default || m)),
  point: defineAsyncComponent(() => import("/tmp/tmpkyj7iuwo/layouts/point.vue").then(m => m.default || m)),
  pref: defineAsyncComponent(() => import("/tmp/tmpkyj7iuwo/layouts/pref.vue").then(m => m.default || m)),
  ranking: defineAsyncComponent(() => import("/tmp/tmpkyj7iuwo/layouts/ranking.vue").then(m => m.default || m)),
  top: defineAsyncComponent(() => import("/tmp/tmpkyj7iuwo/layouts/top.vue").then(m => m.default || m))
}